import type { ApplicationContext } from '@wix/editor-platform-contexts';
import type {
  WorkspaceHost as WorkspaceHostType,
  AppsNamespace,
} from '@wix/workspace';

export class Workspace implements NonNullable<WorkspaceHostType['workspace']> {
  constructor(private applicationContext: Promise<ApplicationContext>) {}

  private async workspaceAPI(): Promise<
    NonNullable<WorkspaceHostType['workspace']>
  > {
    const context = await this.applicationContext;
    const privateAPI = context.getPrivateAPI();
    const workspaceAPI = await privateAPI.workspace;
    return workspaceAPI;
  }

  getContextIds: NonNullable<WorkspaceHostType['workspace']>['getContextIds'] =
    () => {
      throw new Error('Not implemented yet');
    };

  openItemSelector: NonNullable<
    WorkspaceHostType['workspace']
  >['openItemSelector'] = (_args) => {
    throw new Error('Not implemented yet');
  };
  apps: AppsNamespace = {
    startInstallFlow: async (args) => {
      const workspaceAPI = await this.workspaceAPI();
      return workspaceAPI.apps.startInstallFlow(args);
    },
    startPurchasePlanFlow: async (args) => {
      const workspaceAPI = await this.workspaceAPI();
      return workspaceAPI.apps.startPurchasePlanFlow(args);
    },
    startUpdateFlow: async (args) => {
      const workspaceAPI = await this.workspaceAPI();
      return workspaceAPI.apps.startUpdateFlow(args);
    },
    openContactSupport: async (args) => {
      const workspaceAPI = await this.workspaceAPI();
      return workspaceAPI.apps.openContactSupport(args);
    },
  };
}
export class WorkspaceHost {
  #api: Workspace;

  getAPI(): Workspace {
    return this.#api;
  }

  constructor(applicationContext: Promise<ApplicationContext>) {
    this.#api = new Workspace(applicationContext);
  }
}
